import React, { useEffect, useState }  from "react";
import { useHistory, useLocation} from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import { Box, Tab } from "@mui/material";
import { ROUTE_PATHS } from "src/routes/paths";
import { checkAdminRole, fieldSampleAreaEditor } from "src/store/common";
import { useStoreContext } from 'src/store/context';
import { DataImport } from "./DataImport/DataImport";
import { DataRecalcStatus } from "./DataRecalcProcess/DataRecalcStatus";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
      <div
          role="tabpanel"
          style={{padding:0, margin:0}}
          hidden={value !== index}
          id={`simple-tabpanel-${index}`}
          aria-labelledby={`simple-tab-${index}`}
          {...other}
      >
          {value === index && <Box>{children}</Box>}
      </div>
  );
};
function a11yProps(index: number) {
  return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
  };
}
const routes = [ROUTE_PATHS.data_import, ROUTE_PATHS.data_recalc_process]

export const DataProcess = () => {
  const history = useHistory();
  const location = useLocation();
  const [tabValue, setTabValue] = useState(location.pathname?.includes(ROUTE_PATHS.data_recalc_process)? 1:0);
  const [state] = useStoreContext();

  useEffect(()=>{
    if(location.pathname===ROUTE_PATHS.data_process){
      history.push(`${ROUTE_PATHS.data_process}${routes[0]}`)
    }
    if (location?.pathname?.includes(ROUTE_PATHS.data_import)) {
      setTabValue(0)
    }
    else if(location.pathname?.includes(ROUTE_PATHS.data_recalc_process)){
      setTabValue(1)
    }
  },[history, location.pathname])
  return (
    <div style={{padding: '.1%'}}>
      <Tabs 
        scrollButtons={false}
        value={tabValue}
        onChange={(event, newVal)=>{
          setTabValue(newVal); 
          history.push(`${ROUTE_PATHS.data_process}${routes[newVal]}`)
        }}
        className="subtabs"

      >
        {
          state.user && fieldSampleAreaEditor(state.user) &&
          <Tab label="Field Sample Data Import" {...a11yProps(0)}/> 
        }
        
        {
          state.user && checkAdminRole(state.user) &&
          <Tab label="Stations Recalculate"{...a11yProps(1)}/>
        }   
        
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <DataImport/>
      </TabPanel>
      <TabPanel value={tabValue} index={1}>
        <DataRecalcStatus/>
      </TabPanel>
    </div>
  );
};
